import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAutomationV2Route: InvariantJiraRoute = {
	name: 'project-settings-core-automation',
	path: '/jira/core/projects/:projectKey/settings/automate',
};
